import { Component, Inject, OnInit, EventEmitter, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'abtest-v2-migration-dialog',
  templateUrl: './abtest-v2-migration-dialog.component.html',
  styleUrls: ['./abtest-v2-migration-dialog.component.scss'],
  standalone: false,
})
export class AbTestV2MigrationDialog implements OnInit {
  title: string;
  body: string;
  runningAbTestNames: string[];
  @Output() onConfirm = new EventEmitter<void>();
  constructor(
    public dialogRef: MatDialogRef<AbTestV2MigrationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.title = this.data?.title;
    this.body = this.data?.body;
    this.runningAbTestNames = this.data?.runningAbTestNames;
  }

  confirm(event) {
    this.onConfirm.emit();
    this.dialogRef.close();
  }
}
